import axios from "redaxios";

const axiosInstance = axios.create({
  baseURL: process.env.server_url,
  headers: {
    "content-type": "application/json; charset=utf-8",
    "Access-Control-Allow-Credentials": "true",
    Accept: "application/json",
  },
  withCredentials: true,
});

export default axiosInstance;
